import React from 'react';
import styles from './OrderStatusBadge.module.css';

interface OrderStatusBadgeProps {
  status: string;
  variant?: 'order' | 'payment';
}

const ORDER_STATUS_MAP: Record<string, string> = {
  Confirmed: 'green',
  'In Transit': 'yellow',
  Processing: 'orange',
  Delivered: 'green',
  Cancelled: 'red',
};

const PAYMENT_STATUS_MAP: Record<string, string> = {
  Paid: 'green',
  Pending: 'gray',
  Failed: 'red',
};

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({
  status,
  variant = 'order',
}) => {
  const colorMap = variant === 'order' ? ORDER_STATUS_MAP : PAYMENT_STATUS_MAP;
  const color = colorMap[status] || 'gray';

  return (
    <span className={`${styles.badge} ${styles[color]}`}>
      {status}
    </span>
  );
};
